import React, { forwardRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import AppearWrapper from '@Components/Animation/AppearWrapper';

import './Title.custom.scss';
import './Title.theme.scss';

const Title = forwardRef(function Title (props, ref) {
  const {
    isOpen,
    children,
    className,
    horizontalAlignment,
    style
  } = props;

  const bottomLineIcon = horizontalAlignment === 'right' ?
    '#assets-tooltip-tip-left-top' :
    '#assets-tooltip-tip-right';


  return (
    <AppearWrapper
      domRef={ref}
      className={classnames(className,`new-title new-title--${horizontalAlignment}`)}
      isOpen={isOpen}
      style={style}
    >
      <div className='new-title-content'>
        {children}
      </div>
      <div className={`new-title-bottom-line new-title-bottom-line--${horizontalAlignment}`}>
        <svg className={`new-title-bottom-line--icon new-title-bottom-line--icon-${horizontalAlignment}`}>
          <use xlinkHref={bottomLineIcon}/>
        </svg>
      </div>
    </AppearWrapper>
  );
});

Title.defaultProps = {
  horizontalAlignment: 'right',
};

Title.propTypes = {
  horizontalAlignment: PropTypes.oneOf([
    'right',
    'left',
  ]),
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Title;
